import { sendToApi } from 'api/client'
import { useQuery } from 'react-query'

export type AudienceList = {
  id: string
  label: string
  memberCount: number
}

const fetchMailchimpAudienceLists = async (workspaceId: number) => {
  const response = await sendToApi<{
    type: string
    audience_lists: { id: string; name: string; stats: { member_count: number } }[]
  }>(`/w/${workspaceId}/mailchimp/audience_lists`, { method: 'GET' })
  if (response.type !== 'success') {
    throw new Error(response.data)
  }
  const rawLists = response.data.audience_lists
  const audienceLists: AudienceList[] = rawLists
    .filter((list: any) => list.stats && list.stats.member_count >= 0)
    .map((list: any) => ({
      id: list.id,
      label: `${list.name}${list.stats.member_count === 0 ? ' (0 subscribers)' : ''}`,
      memberCount: list.stats.member_count,
    }))

  return audienceLists
}

export function useMailchimpFetchAudienceLists(workspaceId: number, enabled: boolean = true) {
  return useQuery<AudienceList[], Error>(
    ['mailchimp-audience-lists', workspaceId],
    () => fetchMailchimpAudienceLists(workspaceId),
    {
      refetchOnWindowFocus: false,
      retry: false,
      enabled,
    },
  )
}
